/* MirrorVeil page script: loads the current build from Shopify Files (mv-app.js). */
(()=>{var s=document.createElement('script');s.src='https://cdn.shopify.com/s/files/1/0646/9858/1144/files/mv-app.js?v=1792349212';document.head.appendChild(s)})();
